import { Grid } from "@mui/material";
import ModalGeneric from "../Generics/ModalGeneric";
import Titulo3 from "../Generics/Titulo3";
import Info from "../Generics/Info";
import { DadosProgramaManutencao } from "../../model/entities/ProgramaManutencao";
import dayjs from "dayjs";

type Props = {
  open: boolean;
  onClose: () => void;
  dadosManutencao: DadosProgramaManutencao;
};

const ModalProgramaManutencao: React.FC<Props> = (props) => {
  const { open, onClose, dadosManutencao } = props;

  return (
    <ModalGeneric open={open} onClose={onClose}>
      <Grid container spacing={2}>
        <Grid item md={12} style={{ textAlign: "center" }}>
          <Titulo3>Solicitação de Manutenção</Titulo3>
        </Grid>

        <Grid item md={12} xs={12}>
          <Info label={"Motorista"} children={dadosManutencao.nomeMotorista} />
        </Grid>

        <Grid item md={4} xs={12}>
          <Info
            label={"Problema recorrente?"}
            children={dadosManutencao.recorrente}
          />
        </Grid>

        <Grid item md={8} xs={12}>
          <Info
            label={"Telefone do Motorista"}
            children={dadosManutencao.telefoneMotorista.replace(
              "whatsapp:+",
              ""
            )}
          />
        </Grid>

        {dadosManutencao.tipoVeiculo === "Implemento" && (
          <>
            <Grid item md={4} xs={12}>
              <Info
                label={"Tipo do Veículo"}
                children={dadosManutencao.tipoVeiculo}
              />
            </Grid>

            <Grid item md={8} xs={12}>
              <Info
                label={"Placa do Implemento"}
                children={dadosManutencao.placaImplemento}
              />
            </Grid>
          </>
        )}

        {dadosManutencao.tipoVeiculo === "Cavalo" && (
          <>
            <Grid item md={12} xs={12}>
              <Info
                label={"Tipo do veículo"}
                children={dadosManutencao.tipoVeiculo}
              />
            </Grid>
          </>
        )}

        <Grid item md={4} xs={12}>
          <Info
            label={"Prioridade"}
            children={dadosManutencao.prioridadePrograma}
          />
        </Grid>

        <Grid item md={8} xs={12}>
          <Info
            label={"Data da Solicitação"}
            children={dayjs(dadosManutencao.dataHoraSolicitacao).format(
              "DD/MM/YYYY - HH:mm"
            )}
          />
        </Grid>

        <Grid item md={6} xs={12}>
          <Info
            label={"E-mail enviado para"}
            children={dadosManutencao.emailDestinatario}
          />
        </Grid>

        <Grid item md={6} xs={12}>
          <Info
            label={"Email enviado com cópia para"}
            children={dadosManutencao.emailDestinatarioCopia
              .split(",")
              .map((item) => (
                <>
                  {item.trim()}
                  <br />
                </>
              ))}
          />
        </Grid>
      </Grid>
    </ModalGeneric>
  );
};

export default ModalProgramaManutencao;
